var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.427 0C10.9195 0 0 11 0 24.6085C0 35.4865 6.9965 44.6945 16.7025 47.9535C17.916 48.1985 18.3605 47.424 18.3605 46.7725C18.3605 46.202 18.3205 44.2465 18.3205 42.209C11.5255 43.676 10.1105 39.2755 10.1105 39.2755C9.0185 36.4235 7.4005 35.6905 7.4005 35.6905C5.1765 34.183 7.5625 34.183 7.5625 34.183C10.0295 34.346 11.324 36.709 11.324 36.709C13.5075 40.457 17.026 39.398 18.4415 38.746C18.6435 37.157 19.291 36.057 19.9785 35.446C14.559 34.8755 8.857 32.757 8.857 23.3045C8.857 20.6155 9.827 18.4155 11.364 16.7045C11.1215 16.0935 10.272 13.567 11.607 10.1855C11.607 10.1855 13.6695 9.5335 18.32 12.7115C20.311 12.1728 22.3644 11.8988 24.427 11.8965C26.4895 11.8965 28.592 12.182 30.5335 12.7115C35.1845 9.5335 37.247 10.1855 37.247 10.1855C38.582 13.567 37.732 16.0935 37.4895 16.7045C39.067 18.4155 39.997 20.6155 39.997 23.3045C39.997 32.757 34.295 34.8345 28.835 35.446C29.725 36.22 30.493 37.6865 30.493 40.009C30.493 43.309 30.453 45.9575 30.453 46.772C30.453 47.424 30.898 48.1985 32.111 47.954C41.817 44.694 48.8135 35.4865 48.8135 24.6085C48.8535 11 37.894 0 24.427 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.b8cd826daed4bbd0a417fb9abfb0dc56.svg";
export { ForwardRef as ReactComponent };